import React from 'react'
import StudentSidebar from '../StudentSidebar/StudentSidebar'
import { Link } from 'react-router-dom'

const StudentNotesHandouts = () => {
    return (
        <div>
            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <Link to="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </Link>
                            &nbsp;&nbsp;Notes & Handouts
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <StudentSidebar />
                        </div>
                        <div className="col-lg-9">
                            <main className="px-3 py-4">
                                <div className="my-student-sec">
                                    {/* <ul class="nav nav-tabs my-student-nav-sec" id="myTab" role="tablist">
                          <li class="nav-item" role="presentation">
                              <button class="nav-link active" id="home-tab" data-bs-toggle="tab"
                                  data-bs-target="#home" type="button" role="tab" aria-controls="home"
                                  aria-selected="true">One To One</button>
                          </li>
                          <li class="nav-item" role="presentation">
                              <button class="nav-link" id="profile-tab" data-bs-toggle="tab"
                                  data-bs-target="#profile" type="button" role="tab" aria-controls="profile"
                                  aria-selected="false">Group Courses</button>
                          </li>
                      </ul> */}
                                    <div className="tab-content-student my-student-tab-pane" id="myTabContent">
                                        <div
                                            className="tab-pane fade show active"
                                            id="home"
                                            role="tabpanel"
                                            aria-labelledby="home-tab"
                                        >
                                            <div className="row">
                                                <div className="col-lg-6 mt-3 col-md-6 col-md-6">
                                                    <Link to="/student/video-notes">
                                                        <div
                                                            className="card input-card-form notescard"
                                                            style={{ backgroundColor: "aliceblue" }}
                                                        >
                                                            <div className="card-body">
                                                                <div className="row gap-0">
                                                                    <div className="col-lg-4 justify-content-center d-flex col-md-4 col-sm-4">
                                                                        <img
                                                                            src="/assets/img/user/play.png"
                                                                            className="img-fluid"
                                                                            style={{ height: 85, width: "auto", borderRadius: 15 }}
                                                                        />
                                                                    </div>
                                                                    <div className="col-lg-8 m-0 p-0 d-flex text-center justify-content-center align-items-center col-md-8 col-sm-8">
                                                                        <h4 className="mb-0 text-dark text-center">
                                                                            Video Lessons
                                                                        </h4>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Link>
                                                </div>
                                                <div className="col-lg-6 mt-3 col-md-6 col-md-6">
                                                    <Link to="/student/image-notes">
                                                        <div
                                                            className="card input-card-form notescard"
                                                            style={{ backgroundColor: "aliceblue" }}
                                                        >
                                                            <div className="card-body">
                                                                <div className="row gap-0">
                                                                    <div className="col-lg-4 justify-content-center d-flex col-md-4 col-sm-4">
                                                                        <img
                                                                            src="/assets/img/user/sticky-note.png"
                                                                            className="img-fluid"
                                                                            style={{ height: 85, width: "auto", borderRadius: 15 }}
                                                                        />
                                                                    </div>
                                                                    <div className="col-lg-8 m-0 p-0 d-flex text-center justify-content-center align-items-center col-md-8 col-sm-8">
                                                                        <h4 className="mb-0 text-dark text-center">Images</h4>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Link>
                                                </div>
                                                <div className="col-lg-6 mt-3 col-md-6 col-md-6">
                                                    <Link to="/student/pdf-notes">
                                                        <div
                                                            className="card input-card-form notescard"
                                                            style={{ backgroundColor: "aliceblue" }}
                                                        >
                                                            <div className="card-body">
                                                                <div className="row gap-0">
                                                                    <div className="col-lg-4 justify-content-center d-flex col-md-4 col-sm-4">
                                                                        <img
                                                                            src="/assets/img/user/pdf.png"
                                                                            className="img-fluid"
                                                                            style={{ height: 85, width: "auto", borderRadius: 15 }}
                                                                        />
                                                                    </div>
                                                                    <div className="col-lg-8 m-0 p-0 d-flex text-center justify-content-center align-items-center col-md-8 col-sm-8">
                                                                        <h4 className="mb-0 text-dark text-center">PDF</h4>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Link>
                                                </div>
                                                <div className="col-lg-6 mt-3 col-md-6 col-md-6">
                                                    <Link to="/student/ppt-notes">
                                                        <div
                                                            className="card input-card-form notescard"
                                                            style={{ backgroundColor: "aliceblue" }}
                                                        >
                                                            <div className="card-body">
                                                                <div className="row gap-0">
                                                                    <div className="col-lg-4 justify-content-center d-flex col-md-4 col-sm-4">
                                                                        <img
                                                                            src="/assets/img/user/ppt.png"
                                                                            className="img-fluid"
                                                                            style={{ height: 85, width: "auto", borderRadius: 15 }}
                                                                        />
                                                                    </div>

                                                                    <div className="col-lg-8 m-0 p-0 d-flex text-center justify-content-center align-items-center col-md-8 col-sm-8">
                                                                        <h4 className="mb-0 text-dark text-center">
                                                                            PPT
                                                                        </h4>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Link>
                                                </div>

                                                <div className="col-lg-6 mt-3 col-md-6 col-md-6">
                                                    <Link to="/student/doc-notes">
                                                        <div
                                                            className="card input-card-form notescard"
                                                            style={{ backgroundColor: "aliceblue" }}
                                                        >
                                                            <div className="card-body">
                                                                <div className="row gap-0">
                                                                    <div className="col-lg-4 justify-content-center d-flex col-md-4 col-sm-4">
                                                                        <img
                                                                            src="/assets/img/user/doc.png"
                                                                            className="img-fluid"
                                                                            style={{ height: 85, width: "auto", borderRadius: 15 }}
                                                                        />
                                                                    </div>

                                                                    <div className="col-lg-8 m-0 p-0 d-flex text-center justify-content-center align-items-center col-md-8 col-sm-8">
                                                                        <h4 className="mb-0 text-dark text-center">
                                                                            DOC
                                                                        </h4>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Link>
                                                </div>
                                                <div className="col-lg-6 mt-3 col-md-6 col-md-6">
                                                    <Link to="/student/my-queries">
                                                        <div
                                                            className="card input-card-form notescard"
                                                            style={{ backgroundColor: "aliceblue" }}
                                                        >
                                                            <div className="card-body">
                                                                <div className="row gap-0">
                                                                    <div className="col-lg-4 justify-content-center d-flex col-md-4 col-sm-4">
                                                                        <img
                                                                            src="/assets/img/notepad.png"
                                                                            className="img-fluid"
                                                                            style={{ height: 85, width: "auto", borderRadius: 15 }}
                                                                        />
                                                                    </div>
                                                                    <div className="col-lg-8 m-0 p-0 d-flex text-center justify-content-center align-items-center col-md-8 col-sm-8">
                                                                        <h4 className="mb-0 text-dark text-center">My Queries</h4>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                              <div class="row">
                                  <div class="col-lg-6 mt-3 col-md-6 col-md-6">
                                      <div class="card input-card-form bg-white">
                                          <div class="card-body">
                                              <div class="row">

                                                  <div class="col-lg-4">
                                                      <img src="/assets/img/user/user5.jpg"
                                                          class="img-fluid rounded-circle"
                                                          style="height: 7.6rem; width: 100%;" />
                                                  </div>
                                                  <div class="col-lg-8">
                                                      <h5 class="mb-0 text-dark">Annu Yadav</h5>
                                                      <p class="mb-0">Biology</p>
                                                      <p class="mb-0">2 Year experience</p>
                                                      <div class="star">
                                                          <span><i
                                                                  class="fa-solid fa-star text-warning"></i></span>
                                                          <span><i
                                                                  class="fa-solid fa-star text-warning"></i></span>
                                                          <span><i
                                                                  class="fa-solid fa-star text-warning"></i></span>
                                                          <span><i
                                                                  class="fa-solid fa-star text-warning"></i></span>
                                                          <span><i class="fa-solid fa-star"></i></span>
                                                          <span>4.0 <span class="text-primary">(4.0
                                                                  Ratings)</span>
                                                      </div>

                                                      <div class="student_coursebtns d-flex gap-3">
                                                          <Link style="padding-inline: 35px;"
                                                              class="btn btn-primary py-1 mt-1"
                                                              to="/student/student-one-to-one-chat">

                                                              Chat
                                                          </Link>
                                                          <Link class="btn btn-outline-primary py-1 mt-1"
                                                              to="/student/student-mycourse-group-view-details">

                                                              View Details
                                                          </Link>
                                                      </div>
                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                  </div>

                                  <div class="col-lg-6 mt-3 col-md-6 col-md-6">
                                      <div class="card input-card-form bg-white">
                                          <div class="card-body">
                                              <div class="row">

                                                  <div class="col-lg-4">
                                                      <img src="/assets/img/user/user5.jpg"
                                                          class="img-fluid rounded-circle"
                                                          style="height: 7.6rem; width: 100%;" />
                                                  </div>
                                                  <div class="col-lg-8">
                                                      <h5 class="mb-0 text-dark">Annu Yadav</h5>
                                                      <p class="mb-0">Biology</p>
                                                      <p class="mb-0">2 Year experience</p>
                                                      <div class="star">
                                                          <span><i
                                                                  class="fa-solid fa-star text-warning"></i></span>
                                                          <span><i
                                                                  class="fa-solid fa-star text-warning"></i></span>
                                                          <span><i
                                                                  class="fa-solid fa-star text-warning"></i></span>
                                                          <span><i
                                                                  class="fa-solid fa-star text-warning"></i></span>
                                                          <span><i class="fa-solid fa-star"></i></span>
                                                          <span>4.0 <span class="text-primary">(4.0
                                                                  Ratings)</span>
                                                      </div>

                                                      <div class="student_coursebtns d-flex gap-3">
                                                          <Link style="padding-inline: 35px;"
                                                              class="btn btn-primary py-1 mt-1"
                                                              to="/student/student-one-to-one-chat">

                                                              Chat
                                                          </Link>
                                                          <Link class="btn btn-outline-primary py-1 mt-1"
                                                              to="/student/student-mycourse-group-view-details">

                                                              View Details
                                                          </Link>
                                                      </div>

                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                  </div>

                                  <div class="col-lg-6 mt-3 col-md-6 col-md-6">
                                      <div class="card input-card-form bg-white">
                                          <div class="card-body">
                                              <div class="row">

                                                  <div class="col-lg-4">
                                                      <img src="/assets/img/user/user5.jpg"
                                                          class="img-fluid rounded-circle"
                                                          style="height: 7.6rem; width: 100%;" />
                                                  </div>
                                                  <div class="col-lg-8">
                                                      <h5 class="mb-0 text-dark">Annu Yadav</h5>
                                                      <p class="mb-0">Biology</p>
                                                      <p class="mb-0">2 Year experience</p>
                                                      <div class="star">
                                                          <span><i
                                                                  class="fa-solid fa-star text-warning"></i></span>
                                                          <span><i
                                                                  class="fa-solid fa-star text-warning"></i></span>
                                                          <span><i
                                                                  class="fa-solid fa-star text-warning"></i></span>
                                                          <span><i
                                                                  class="fa-solid fa-star text-warning"></i></span>
                                                          <span><i class="fa-solid fa-star"></i></span>
                                                          <span>4.0 <span class="text-primary">(4.0
                                                                  Ratings)</span>
                                                      </div>

                                                      <div class="student_coursebtns d-flex gap-3">
                                                          <Link style="padding-inline: 35px;"
                                                              class="btn btn-primary py-1 mt-1"
                                                              to="/student/student-one-to-one-chat">

                                                              Chat
                                                          </Link>
                                                          <Link class="btn btn-outline-primary py-1 mt-1"
                                                              to="/student/student-mycourse-group-view-details">

                                                              View Details
                                                          </Link>
                                                      </div>
                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                  </div>

                                  <div class="col-lg-6 mt-3 col-md-6 col-md-6">
                                      <div class="card input-card-form bg-white">
                                          <div class="card-body">
                                              <div class="row">

                                                  <div class="col-lg-4">
                                                      <img src="/assets/img/user/user5.jpg"
                                                          class="img-fluid rounded-circle"
                                                          style="height: 7.6rem; width: 100%;" />
                                                  </div>
                                                  <div class="col-lg-8">
                                                      <h5 class="mb-0 text-dark">Annu Yadav</h5>
                                                      <p class="mb-0">Biology</p>
                                                      <p class="mb-0">2 Year experience</p>
                                                      <div class="star">
                                                          <span><i
                                                                  class="fa-solid fa-star text-warning"></i></span>
                                                          <span><i
                                                                  class="fa-solid fa-star text-warning"></i></span>
                                                          <span><i
                                                                  class="fa-solid fa-star text-warning"></i></span>
                                                          <span><i
                                                                  class="fa-solid fa-star text-warning"></i></span>
                                                          <span><i class="fa-solid fa-star"></i></span>
                                                          <span>4.0 <span class="text-primary">(4.0
                                                                  Ratings)</span>
                                                      </div>

                                                      <div class="student_coursebtns d-flex gap-3">
                                                          <Link class="btn btn-primary py-1 mt-1 "
                                                              style="padding-inline: 35px;" to="/student/chat">

                                                              Chat
                                                          </Link>
                                                          <Link class="btn btn-outline-primary py-1 mt-1"
                                                              to="/student/student-mycourse-group-view-details">

                                                              View Details
                                                          </Link>
                                                      </div>
                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div> */}
                                    </div>
                                </div>
                            </main>


                        </div>
                    </div>
                </div>
            </section>

        </div>
    )
}

export default StudentNotesHandouts